import HeroSection from "../HeroSection";
import React from "react";
import MySkills from "../MySkills";
import AboutMe from "../AboutMe";
import Myportfolio from "../MyPortfolio";
import ContactMe from "../ContactMe";
import Footer from "../Footer";

export default function Home () {
    return (
        <>
            <HeroSection />           
            <AboutMe />
            <MySkills />
            <Myportfolio />
            <ContactMe />
            <Footer />
        </>
    );
}